export const GET_TASKS_QUERY_KEY = 'home/useGetTasks';
export const GET_PROCESS_INFO_QUERY_KEY = 'home/useGetProcessInfo';
